import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
var subheading = designTokenFonts.subheading,
  mini = designTokenFonts.mini;
export var container = hasBorder => /*#__PURE__*/css("display:flex;flex-direction:row;justify-content:left;align-items:center;gap:8px;padding:16px;text-decoration:none;border-radius:3px;background:", colors.neutral.surface.default, ";", hasBorder && /*#__PURE__*/css("border:1px solid ", colors.neutral.trim.default, ";"));
export var title = /*#__PURE__*/css(subheading, " color:", colors.neutral.heavy.default, ";");
export var text = /*#__PURE__*/css(mini, " color:", colors.neutral.heavy.default, ";");
export var textContainer = {
  name: "j7qwjs",
  styles: "display:flex;flex-direction:column;"
};
export var iconContainer = {
  name: "xvmrez",
  styles: "width:56px;height:56px;image{width:100%;height:100%;}"
};
export var linkContainer = spacedEvenly => /*#__PURE__*/css("display:flex;flex-direction:row;justify-content:", spacedEvenly ? 'space-evenly' : 'space-between', ";align-items:center;width:100%;");
export var chevron = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";");